import { ReactNode } from "react";
import { STYLE } from "@jasper/shared";
import { NotificationBadge } from "./NotificationBadge";
import { INDENT_STEP } from "./helpers/navMenu";

export const NavLink = (props: {
  title: string;
  onClick: () => void;
  active?: boolean;
  notificationNumber?: number;
  icon?: ReactNode;
  indent?: number;
}) => {
  return (
    <button
      type="button"
      style={{
        font: "inherit",
        background: "none",
        border: "none",
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        cursor: "pointer",
        color: props.active ? STYLE.primary : "#050027",
        fontWeight: 650,
        textAlign: "left",
        padding: 0,
        paddingLeft: `${(props.indent ?? 0) * INDENT_STEP}px`,
      }}
      onClick={props.onClick}
    >
      {props.icon && (
        <span style={{ display: "flex", flexShrink: 0 }}>{props.icon}</span>
      )}
      <span style={{ overflowWrap: "break-word" }}>
        {props.title.replaceAll("_", " ")}
      </span>
      {props.notificationNumber ? (
        <NotificationBadge count={props.notificationNumber} />
      ) : null}
    </button>
  );
};
